import type { Route } from '@angular/router';
import type { DeactivationGuarded } from '@commons/services/can-deactivate-confirmation.service';
import type { Observable } from 'rxjs';

import { archivingResolver } from '@features/partners/builder/settings/platform-access/archiving.resolver';
import { indexationResolver } from '@features/partners/builder/settings/platform-access/indexation/indexation.resolver';
import { PLATFORM_ACCESS_ROUTING } from '@features/partners/builder/settings/platform-access/routes';
import { IndexationWebservice } from '@webservices/indexation/indexation.webservice';

export const PLATFORM_ACCESS_ROUTES: Route[] = [
  {
    path: PLATFORM_ACCESS_ROUTING.Archive,
    resolve: {
      archivingStatus: archivingResolver,
    },
    loadComponent: async () =>
      (await import('@features/partners/builder/settings/platform-access/archiving/archiving.component'))
        .ArchivingComponent,
  },
  {
    path: PLATFORM_ACCESS_ROUTING.CoPlatform,
    canDeactivate: [(comp: DeactivationGuarded): Observable<boolean> => comp.canDeactivate()],
    loadComponent: async () =>
      (await import('@features/partners/builder/settings/platform-access/co-platform/co-platform.component'))
        .CoPlatformComponent,
  },
  {
    path: PLATFORM_ACCESS_ROUTING.Indexation,
    canDeactivate: [(comp: DeactivationGuarded): Observable<boolean> => comp.canDeactivate()],
    resolve: {
      indexation: indexationResolver,
    },
    providers: [IndexationWebservice],
    loadComponent: async () =>
      (await import('@features/partners/builder/settings/platform-access/indexation/indexation.component'))
        .IndexationComponent,
  },
  {
    path: '',
    redirectTo: PLATFORM_ACCESS_ROUTING.Indexation,
    pathMatch: 'full',
  },
];
